import { render, staticRenderFns } from "./SettingsLevel.vue?vue&type=template&id=3e8c06fa"
import script from "./SettingsLevel.vue?vue&type=script&lang=ts"
export * from "./SettingsLevel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports